
import RegisteredUsers from "./RegisteredUsers";
import NonRegisteredUsers from './NonRegisteredUsers'


export const type = {
    registered: RegisteredUsers,
    nonRegistered: NonRegisteredUsers
}
